import Const from 'const';
import {CorrelationStackedTeamsList as NFLCorrelationStackedTeamsList} from './sports/nfl/classic';

const classesMap = {
    [Const.LEAGUE_NFL]: {
        [Const.GAME_TYPE_CLASSIC]: NFLCorrelationStackedTeamsList,
    },
};

const Factory = {
    getComponent(sportConfig) {
        const sport = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        return classesMap[sport][gameType] || null;
    },
};

export {Factory};
